module.exports = __webpack_public_path__ + "img/icon_oil.aba3989b.png";